{
  "header": "<h2>Veuillez poursuivre votre réservation en utilisant un autre mode de paiement</h2>",
  "cannot-proceed": "<p>Nous ne sommes pas en mesure de donner suite à votre demande de prêt. Veuillez utiliser un autre mode de paiement pour compléter votre réservation auprès de votre agent.</p>",
  "click-here": "cliquez ici",
  "uplift": {
    "payLink": "https://pay.uplift.com",
    "additional-information": "<p>Si vous voulez en savoir plus sur notre décision concernant votre demande, <0/>. Vous trouverez également ces détails dans votre compte sur <1>pay.uplift.com</1>.</p>",
    "questions": "<p>Questions? Veuillez contacter Uplift</p>"
  },
  "flexpay": {
    "payLink": "https://upgrade.com/pay",
    "additional-information": "<p>Si vous voulez en savoir plus sur notre décision concernant votre demande, <0/>. Vous trouverez également ces détails dans votre compte sur <1>upgrade.com/pay</1>.</p>",
    "questions": "<p>Questions? Veuillez contacter </p>"
  }
}
